import { LicenseUsageSummary } from '../interfaces';

// Combine current and prior-period overage when calculating the capacity increase required.
export function getRequiredAdditionalLicenses(
    usage: Pick<LicenseUsageSummary, 'availableLicenses' | 'outstandingOverageLicenses'>
): number {
    return Math.max(0, -usage.availableLicenses) + Math.max(0, usage.outstandingOverageLicenses);
}
